/* Gold & Richie — cart
   Every mutation re-renders the drawer through the Section Rendering API so the
   markup stays the single source of truth rather than being patched in JS. */

(function () {
  'use strict';

  var GR = window.GR;
  if (!GR) return;

  var DRAWER_SECTION = 'cart-drawer';
  var pending = false;

  /* ------------------------------------------------------------- rendering */

  function sectionsUrl(sections) {
    return GR.routes.root + '?sections=' + sections.join(',');
  }

  function replaceDrawer(html) {
    var current = document.getElementById('gr-cart-drawer');
    if (!current || !html) return;

    var wasOpen = current.dataset.open === 'true';
    var parsed = new DOMParser().parseFromString(html, 'text/html');
    var next = parsed.getElementById('gr-cart-drawer');
    if (!next) return;

    if (wasOpen) {
      next.dataset.open = 'true';
      next.removeAttribute('hidden');
      next.setAttribute('aria-hidden', 'false');
    }
    next._returnFocus = current._returnFocus;

    current.replaceWith(next);
    loadRecommendations();
  }

  function updateCount(count) {
    document.querySelectorAll('[data-gr-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });

    document.querySelectorAll('.gr-header__cart').forEach(function (el) {
      el.setAttribute('aria-label', el.getAttribute('aria-label').replace(/\d+/, count));
    });
  }

  function refresh(openAfter) {
    return fetch(sectionsUrl([DRAWER_SECTION]))
      .then(function (r) { return r.json(); })
      .then(function (data) {
        replaceDrawer(data[DRAWER_SECTION]);
        return fetch(GR.routes.cart + '.js');
      })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateCount(cart.item_count);
        if (openAfter && GR.cartType === 'drawer') GR.openDrawer('gr-cart-drawer');
        document.dispatchEvent(new CustomEvent('gr:cart:updated', { detail: { cart: cart } }));
      });
  }

  GR.refreshCart = refresh;

  /* ----------------------------------------------------------------- errors */

  function showError(form, message) {
    if (!form) {
      GR.announce(message);
      return;
    }
    var slot = form.querySelector('[data-gr-form-error]');
    if (slot) {
      slot.textContent = message;
      slot.hidden = false;
    }
    GR.announce(message);
  }

  function clearError(form) {
    if (!form) return;
    var slot = form.querySelector('[data-gr-form-error]');
    if (slot) { slot.textContent = ''; slot.hidden = true; }
  }

  /* ------------------------------------------------------------ add to cart */

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('[data-gr-product-form]');
    if (!form) return;

    event.preventDefault();

    /* Required line item properties, such as ring size. The form carries
       novalidate, so the browser will not enforce this on its own. */
    var required = form.querySelector('[data-gr-required-property]');
    if (required && !required.value) {
      showError(form, (GR.strings && GR.strings.propertyRequired) || 'Please choose an option.');
      required.focus();
      return;
    }

    if (pending) return;

    var button = form.querySelector('[type="submit"]');
    var data = new FormData(form);

    pending = true;
    clearError(form);
    if (button) button.dataset.loading = 'true';

    fetch(GR.routes.cartAdd, {
      method: 'POST',
      headers: { Accept: 'application/javascript' },
      body: data
    })
      .then(function (response) {
        return response.json().then(function (body) {
          if (!response.ok) throw body;
          return body;
        });
      })
      .then(function (item) {
        GR.announce(
          (item.product_title || '') + ' ' + ((GR.strings && GR.strings.addedToCart) || 'added to your cart')
        );
        return refresh(true);
      })
      .catch(function (error) {
        showError(form, (error && error.description) || (error && error.message) || GR.strings.cartError);
      })
      .then(function () {
        pending = false;
        if (button) delete button.dataset.loading;
      });
  });

  /* ------------------------------------------------------- quantity changes */

  function changeLine(key, quantity) {
    if (pending) return;
    pending = true;

    var item = document.querySelector('[data-gr-cart-item="' + CSS.escape(key) + '"]');
    if (item) item.dataset.busy = 'true';

    fetch(GR.routes.cartChange, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (response) {
        return response.json().then(function (body) {
          if (!response.ok) throw body;
          return body;
        });
      })
      .then(function () { return refresh(false); })
      .catch(function (error) {
        GR.announce((error && error.description) || GR.strings.cartError);
        return refresh(false);
      })
      .then(function () { pending = false; });
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-gr-cart-qty]');
    if (!btn) return;
    event.preventDefault();
    changeLine(btn.getAttribute('data-gr-cart-qty'), parseInt(btn.getAttribute('data-gr-qty-value'), 10));
  });

  document.addEventListener('change', function (event) {
    var input = event.target.closest('[data-gr-cart-qty-input]');
    if (!input) return;
    var value = parseInt(input.value, 10);
    if (isNaN(value) || value < 0) value = 0;
    changeLine(input.getAttribute('data-gr-cart-qty-input'), value);
  });

  /* ----------------------------------------------------------------- notes */

  var noteTimer;
  document.addEventListener('input', function (event) {
    var note = event.target.closest('[data-gr-cart-note]');
    if (!note) return;

    window.clearTimeout(noteTimer);
    noteTimer = window.setTimeout(function () {
      fetch(GR.routes.cartUpdate, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ note: note.value })
      });
    }, 600);
  });

  /* ------------------------------------------------------- recommendations */

  function loadRecommendations() {
    var slot = document.querySelector('[data-gr-cart-recs]');
    if (!slot) return;

    var productId = slot.getAttribute('data-product-id');
    if (!productId) return;

    var url = GR.routes.root + 'recommendations/products?section_id=cart-recommendations' +
      '&product_id=' + productId + '&limit=3&intent=complementary';

    fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var content = parsed.querySelector('[data-gr-recs-inner]');
        if (content && content.children.length) {
          slot.innerHTML = content.innerHTML;
          if (GR.observeReveals) GR.observeReveals(slot);
        }
      })
      .catch(function () { /* recommendations are an enhancement, never a blocker */ });
  }

  document.addEventListener('DOMContentLoaded', loadRecommendations);
  loadRecommendations();

  /* --------------------------------------------- express checkout gating */

  /* The dynamic checkout button posts straight to Shopify without passing
     through the handler above, so it is hidden until every required property
     has a value. CSS does this on load; this keeps it correct on change and
     covers browsers without :has(). */
  function syncExpressCheckout(form) {
    var wrap = form.querySelector('[data-gr-dynamic-checkout]');
    if (!wrap) return;
    var required = form.querySelector('[data-gr-required-property]');
    wrap.hidden = !!(required && !required.value);
  }

  document.addEventListener('change', function (event) {
    var field = event.target.closest('[data-gr-required-property]');
    if (!field) return;
    var form = field.closest('[data-gr-product-form]');
    if (!form) return;
    clearError(form);
    syncExpressCheckout(form);
  });

  document.addEventListener('DOMContentLoaded', function () {
    var forms = document.querySelectorAll('[data-gr-product-form]');
    for (var i = 0; i < forms.length; i++) syncExpressCheckout(forms[i]);
  });

})();
